import React from 'react';
import Loader from 'react-loader-advanced';
import PropTypes from 'prop-types';
var SboAddressInfo = function SboAddressInfo(props) {
  var _address$shippingAddr, _address$shippingAddr2, _address$shippingAddr3, _address$shippingAddr4, _address$shippingAddr5, _address$shippingAddr6, _address$shippingAddr7;
  var addressInfo = props.addressInfo,
    error = props.error,
    isLoading = props.isLoading;
  var address = addressInfo[0];
  return /*#__PURE__*/React.createElement("div", {
    className: "section address-information"
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading"
  }, "Address information"), /*#__PURE__*/React.createElement(Loader, {
    show: isLoading
  }, /*#__PURE__*/React.createElement("div", {
    className: "addresses"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ship-from"
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading"
  }, "Ship from address:"), !error ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, address === null || address === void 0 || (_address$shippingAddr = address.shippingAddress) === null || _address$shippingAddr === void 0 ? void 0 : _address$shippingAddr.nameLine1, /*#__PURE__*/React.createElement("br", null), "Account: ", address === null || address === void 0 || (_address$shippingAddr2 = address.shippingAddress) === null || _address$shippingAddr2 === void 0 ? void 0 : _address$shippingAddr2.shipToCode, " ", address === null || address === void 0 || (_address$shippingAddr3 = address.shippingAddress) === null || _address$shippingAddr3 === void 0 ? void 0 : _address$shippingAddr3.nameLine1, /*#__PURE__*/React.createElement("br", null), address === null || address === void 0 || (_address$shippingAddr4 = address.shippingAddress) === null || _address$shippingAddr4 === void 0 ? void 0 : _address$shippingAddr4.addressLine1, ", ", address === null || address === void 0 || (_address$shippingAddr5 = address.shippingAddress) === null || _address$shippingAddr5 === void 0 ? void 0 : _address$shippingAddr5.city, ", ", address === null || address === void 0 || (_address$shippingAddr6 = address.shippingAddress) === null || _address$shippingAddr6 === void 0 ? void 0 : _address$shippingAddr6.county, ", ", address === null || address === void 0 || (_address$shippingAddr7 = address.shippingAddress) === null || _address$shippingAddr7 === void 0 ? void 0 : _address$shippingAddr7.postalCode)) : /*#__PURE__*/React.createElement("div", null, "No information available.")), /*#__PURE__*/React.createElement("div", {
    className: "ship-to"
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading"
  }, "Ship to address:"), /*#__PURE__*/React.createElement("div", null, "SBO Hearing US", /*#__PURE__*/React.createElement("br", null), "580 Howard Avenue, Somerset, NJ 08873")))));
};
SboAddressInfo.propTypes = {
  isLoading: PropTypes.bool,
  addressInfo: PropTypes.arrayOf(PropTypes.shape({
    shipToCode: PropTypes.string,
    shippingAddress: PropTypes.shape({
      nameLine1: PropTypes.string,
      nameLine2: PropTypes.string,
      addressLine1: PropTypes.string,
      addressLine2: PropTypes.string,
      city: PropTypes.string,
      county: PropTypes.string,
      postalCode: PropTypes.string
    })
  }))
};
SboAddressInfo.defaultProps = {
  isLoading: false,
  addressInfo: [{
    shipToCode: '',
    shippingAddress: {
      nameLine1: '',
      nameLine2: '',
      addressLine1: '',
      addressLine2: '',
      city: '',
      county: '',
      postalCode: ''
    }
  }]
};
export default SboAddressInfo;